import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import HeadshotComponent from '../headshot';
import OpenGraphPreviewComponent from '../open_graph_preview';
import moment from 'moment';

const Post = ({ post, creator, community }) => {
  let focusable;

  if (post.focus) {
    focusable = useRef(null);

    useEffect(() => {
      $(focusable.current).focus();
    }, []);
  }

  const {
    createdAt,
    subject,
    category,
    body
  } = post;

  const renderSubject = () => {
    if (!(subject && subject.length)) { return; }

    return (
      <div className="message-subject">
        <span className="t3 w3">{ subject }</span>
      </div>
    );
  }

  const renderCommunityLink = () => {
    if (!(community && community.slug && community.slug.length)) { return; }

    return (
      <span>
        <i className="fas fa-long-arrow-alt-right ml-10 mr-10"></i>
        <a className="theme" href={ `/${community.slug}` }>
          { community.name }
        </a>
      </span>
    );
  }

  const renderCategory = () => {
    if (!(category && category.length) || category === 'generic') { return; }

    return (
      <a className="message-tag btn-main btn-tiny btn-reverse pull-right">
        { category.toUpperCase() }
      </a>
    );
  }

  return (
    <div className="message post">
      <HeadshotComponent user={ creator } width={ 56 } />

      <div className="message-right">
        <p className="t5 w3 message-name">
          <a className="text-black" key={ creator.id } href={ creator.profileLink }>{ creator.displayName }</a>
          { renderCommunityLink()  }

          <span className="hidden-xs">
            { renderCategory() }
          </span>
        </p>

        <p className="t6 dark-gray" style={{ marginBottom: '-2px' }}>
          { creator?.companyTitle?.replace(' at ', ', ') }
        </p>

        <p className="t6 dark-gray" title={ createdAt }>
          { moment(createdAt).fromNow() }
        </p>
      </div>

      <div className="message-main pt-20">
        <div className="message-header mb-5">
          { renderSubject() }
          <div className="visible-xs pull-right">
            { renderCategory() }
          </div>
        </div>

        <div className="t5 content"
          dangerouslySetInnerHTML={{ __html: body }}>
        </div>

        <OpenGraphPreviewComponent text={ body } />
      </div>
    </div>
  );
};

Post.propTypes = {
  post: PropTypes.object.isRequired
};

export default Post;
